import { CaseAudit } from "./caseAudit"
import { FieldTypeId } from "./fieldTypes"

export interface FieldReassignmentAuditItem {
	caseNumber: string
	caseTitle: string
	caseCreationDate: Date
	caseTemplateId: string
	isForecastedCase: boolean
	fieldId: string
	lastAssignmentAt: Date
	assignmentCount: number
	assignmentAudits: CaseAudit[]
}

export interface AuditTrailEntry {
	changedAt: string
	changedBy: string
	oldValue: string | null
	newValue: string | null
}

export const reassignmentAuditSupportedDataTypes: FieldTypeId[] = [
	FieldTypeId.Text, FieldTypeId.TextArea, FieldTypeId.Number, FieldTypeId.Date, FieldTypeId.DateTime,
	FieldTypeId.List, FieldTypeId.Checkbox, FieldTypeId.Dollar
]

export const reassignmentAuditSupportedBuiltInCaseColumnKeys: string[] = [
	"title", "summary", "statusId", "severityId", "cadenceEnabled"
]
